(function () {
  angular
    .module('kareo.ui.shared.directives.user.k-user-profile-photo-view', [
      'flow',
      'kareo.ui.shared.directives.templates',
      'kareo.ui.shared.directives.user.k-user-profile-image'
    ])
    .component('kUserProfilePhotoView', {
      bindings: {
        onImageSelect: '&', // param: imageBase64 - base64 encoded image,
        user: '<'
      },
      controller,
      controllerAs: 'vm',
      template: require('./k-user-profile-photo-view.pug')()
    });

  function controller() {
    const vm = this;

    vm.fileAdded = fileAdded;

    // -----------------------------------------------------------------------

    function fileAdded(flow) {
      const fileReader = new FileReader();
      fileReader.onload = onFileUpload;
      fileReader.readAsDataURL(flow.file);
    }

    function onFileUpload(event) {
      vm.onImageSelect({ imageBase64: event.target.result });
    }
  }
})();
